<template>
	<div class="window window-new ofH tra" status="false">
		<div class="body body-full bgContent">
			<div class="head cb fsLv5 posR">
				<span class="title fsLv5">{{ title }}</span>
				<div class="posA rcC">
					<slot name="headCenter"></slot>
				</div>
				<div class="fR cb ml1x_E tra-fast_E vaM_E">
					<button v-if="hideBtn" class="subBtn close" :title="hideBtnText">{{ hideBtnText }}</button>
					<slot name="headButton"></slot>
				</div>
			</div>
			<div class="content pt3x">
				<slot></slot>
			</div>
		</div>
	</div>
</template>
<script>
import * as lib from "@/util/lib.js";
import { getLanguageStr } from "@/util/language.js";

export default {
	name: "WindowForNew",
	props: {
		title: {
			type: String,
			default: "",
		},
		hideBtn: {
			//关闭按钮
			type: Boolean,
			default: false,
		},
		hideBtnText: {
			type: String,
			default: getLanguageStr("cmd153", "关闭"),
		},
	},
	components: {},
	created() {},
	data() {
		return {
			display: true,
			data: "", //待提交的数据
		};
	},
	methods: {
		getLanguageStr,
		getTypeText: lib.getTypeText,
		show: function (option) {
			// this.display=true;
			setTimeout(() => {
				//为了稳定的出动画效果
				// lib.fillHeight();
				lib.windowCtrl($(this.$el), "true", {
					end: () => {
						// lib.setScroll($(this.$el).find("[scroll]"));
						this.showEndDo(0, option ? option.end : null);
					},
				});
				// if(option){
				// 	if(option.end){
				// 		setTimeout(option.end,600);
				// 	}
				// }
			}, 0);
		},
		showEndDo(delayMs, fn) {
			//确保动画完成再执行
			if (fn) {
				setTimeout(() => {
					// if($(this.$el).offset().top-$(window).scrollTop()==0){
					// 	lib.fillHeight();
					fn();
					// }
					// else{
					// 	this.showEndDo(100,fn);
					// }
				}, delayMs);
			}
		},
		hide: function (option) {
			if (option == "cancel") this.$emit("Cancel");
			this.$emit("Close");
			lib.windowCtrl($(this.$el), "false", {
				end: () => {
					if (option && option.end) option.end();
					this.$emit("Closed");
					// this.display=false;
				},
			});
		},
	},
	watch: {},
	mounted() {
		let $this = this;
		$(this.$el).on("click", ".head .close", function (e) {
			//close class的dom设置关闭窗口
			e.stopPropagation();
			$this.hide("cancel");
		});
	},
};
</script>
<style lang="scss" scoped>
.window {
	z-index: 25;
	width: 100%;
	height: 100%;
	&[status="false"] {
		opacity: 1;
		transform: translate3d(0, -100%, 0);
		> .body {
			transform: rotatex(0) translatez(0);
		}
	}
	&[status="true"] {
		transform: translate3d(0, 0, 0);
	}
	.body {
		box-shadow: none;
		> .head {
			height: 9.25rem;
			line-height: 9.25rem;
			cursor: auto;
			background-color: $windowBarBgColor;
			padding: {
				top: unset;
				bottom: unset;
				left: 3rem;
			} //adjust-color($mainColor,$hue:228,$saturation:2,$lightness:96)
			button {
				height: $sizeM;
			}
			.close {
				position: unset;
				padding-top: 0;
				padding-bottom: 0;
				margin-top: 0;
			}
		}
		> .content {
			width: auto;
			max-height: unset;
			margin {
				top: 0;
			}
			padding: {
				right: 0;
				left: 0;
			}
		}
	}
}
/*
.add-fade-enter-active,.add-fade-leave-active  {
	transition: all .4s ease-out;
}
.add-fade-enter,.add-fade-leave-to {
	transform: translate3d(0, -100%, 0);
	opacity: 0;
}
.add-fade-enter-to,.add-fade-leave{
    transform: translate3d(0, 0, 0);
	opacity: 1;
}

.add-clue{
	position: fixed;
	width:100%;
	height:100%;
	left:0;
	top:0;
	background: #fff;
	z-index:11;
	.add-header{
		width: 100%;
		height: rem(70);
		.add-header-wrap {
			width:80%;
			height: 100%;
			margin: 0 auto;
			h3{
				font-size: rem(28);
				margin:0;
				line-height: rem(70);
				float:left;
				font-weight: normal;
			}
			.btns{
				float: right;
				line-height: rem(70);
				button {
					min-width:rem(100);
					margin-right:rem(10);
					font-size: rem(14);
				}
			}
		}
	}
	.clue-content{
		width: 80%;
		margin: 0 auto;
		padding-top:rem(30);
		tr{
			label input{
				margin-bottom: 2px;
				margin-right: 5px;
			}
		}
		tbody tr{
			&.extra-info{
				height:rem(10);
				color:#ff595f;
				td {
					padding-top: 0 !important;
				}
			}
		}
		.textarea{
			border:1px solid rgba(0, 0, 0, 0.1);
			width:100%;
			height:rem(100);
			border-radius: .2rem;
			position: absolute;
			top: rem(-10);
		}
		em{
			margin-right:2px;
			color:$red;
		}
		.new{
			color:$mainColor;margin-left:rem(15);
		}
		.hour{
			display: inline-block;
			vertical-align: middle;
		}
		img{
			width:rem(80);
			height:rem(80);
			margin-right:rem(10);
		}
		.customer-list{
			visibility: visible;
			opacity: 1;
			min-width: 80%;
			// max-height: rem(260);
			height: rem(260);
			background: #fff;
			// margin: rem(5) 0 0;
			border:1px solid #ccc;
			position: absolute;
			left: 0;
			z-index: 2;
			border-radius: rem(2);
			.list{
				// max-height: rem(210);
				height: rem(210);
				width :100%;
				li{
					transition: all .2s;
					height: rem(36);
					padding: 0 rem(10);
					list-style-type: none;
					color:#666;
					cursor: pointer;
					div.t {
						padding-top: rem(5);
						span:nth-of-type(1){float: left;}
						span:nth-of-type(2){float: right;}
					}
					div.b {
						span:nth-of-type(1){float: left;}
						font-weight: normal;
					}
					&:hover,&.active{
						background:#ebf1f2;
					}
				}
				.loading-wrap{
					height:rem(210);
					vertical-align: middle;
				}
				.no-data-wrap{
					height:rem(210);
					vertical-align: middle;
					line-height: rem(210);
					opacity: .5;
					color:#000;
					text-align: center;
				}
			}
			.page {
				height: rem(50);
				line-height: rem(50);
			}
		}
		// div{
		// 	width:300px;
		// 	height:600px;
		// 	border:1px solid red;
		// }
	}
}
*/
</style>



// WEBPACK FOOTER //
// src/components/common/ui/WindowForNew.vue